module.exports = __webpack_public_path__ + "static/media/get-their-attention.e83be245.png";